<template>
  <div v-if="variant === variants.v1"
    class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-7 tw-px-4 tw-py-9"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded)`"
    style="border-radius: var(--rounded)"
  >
    <h3>{{ vars.titleText }}</h3>

    <div
      class="n-team-card tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-6 tw-rounded-lg tw-p-3 hover:!tw-scale-[unset] hover:!tw-shadow-none"
    >
      <library-image :src="vars.memberPhotoImage" :hRatio="1.5" :wRatio="1" style="border-radius: var(--rounded)" />
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-center">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-break-words">
          <h6>{{ vars.memberNameText }}</h6>
          <p class="!tw-font-bold">{{ vars.memberRoleText }}</p>
        </div>
        <div class="tw-flex tw-w-full tw-flex-col tw-items-center">
          <div
            v-if="vars.memberPhoneText"
            class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-break-words"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.34 10.2533C12.52 10.2533 11.7267 10.12 10.9867 9.88C10.8707 9.8407 10.7461 9.83487 10.627 9.86317C10.5079 9.89147 10.3992 9.95275 10.3133 10.04L9.26667 11.3533C7.38 10.4533 5.61333 8.75333 4.67333 6.8L5.97333 5.69333C6.15333 5.50667 6.20667 5.24667 6.13333 5.01333C5.88667 4.27333 5.76 3.48 5.76 2.66C5.76 2.3 5.46 2 5.1 2H2.79333C2.43333 2 2 2.16 2 2.66C2 8.85333 7.15333 14 13.34 14C13.8133 14 14 13.58 14 13.2133V10.9133C14 10.5533 13.7 10.2533 13.34 10.2533Z"
                fill="black"
              />
            </svg>
            <nuxt-link :to="`tel:${vars.memberPhoneUrl}`" class="n-link">
              <p class="tw-max-w-full">
                {{ vars.memberPhoneUrl }}
              </p>
            </nuxt-link>
          </div>
          <div v-if="vars.memberEmailUrl" class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-wrap">
            <span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.66671 13.3334C2.30004 13.3334 1.98604 13.2027 1.72471 12.9414C1.46338 12.68 1.33293 12.3662 1.33338 12V4.00002C1.33338 3.63335 1.46404 3.31935 1.72538 3.05802C1.98671 2.79669 2.30049 2.66624 2.66671 2.66669H13.3334C13.7 2.66669 14.014 2.79735 14.2754 3.05869C14.5367 3.32002 14.6672 3.6338 14.6667 4.00002V12C14.6667 12.3667 14.536 12.6807 14.2747 12.942C14.0134 13.2034 13.6996 13.3338 13.3334 13.3334H2.66671ZM8.00004 8.66669L13.3334 5.33335V4.00002L8.00004 7.33335L2.66671 4.00002V5.33335L8.00004 8.66669Z"
                  fill="black"
                />
              </svg>
            </span>
            <nuxt-link :to="`mailto:${vars.memberEmailUrl}`" class="n-link">
              <p class="tw-break-all tw-lowercase">
                {{ vars.memberEmailUrl }}
              </p>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>


 <div
  v-if="variant === variants.v2 && property?.property_manager"
  class="tw-w-full tw-max-w-xl tw-mx-auto  tw-border  tw-p-6 md:tw-p-8 tw-flex tw-flex-col tw-items-center tw-text-center tw-gap-3"
style="border-radius: var(--rounded); border-color: var(--c-border)">
  <!-- Property Manager Photo -->
  <div class="tw-mb-2">
    <div
      class="tw-h-20 tw-w-20 tw-overflow-hidden tw-rounded-full tw-border-4 tw-shadow-md"
      style="border-color: var(--c-border)"
    >
      <library-image
        v-if="property.property_manager.image"
        :src="property.property_manager.image"
        :alt="`${property.property_manager.name} ${property.property_manager.surname}`"
        :title="`${property.property_manager.name} ${property.property_manager.surname}`"
        image-class="tw-h-full tw-w-full tw-object-cover"
        :design-width="80"
        :design-height="80"
      />
      <!-- Fallback avatar -->
      <div v-else class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-bg-gray-200">
        <svg class="tw-h-10 tw-w-10 tw-text-gray-400" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </div>

  <!-- Property Manager Name -->
  <div class="tw-mb-1">
    <h5 class="tw-font-semibold tw-text-gray-900">
      {{ property.property_manager.name }} {{ property.property_manager.surname }}
    </h5>
    <p class="tw-text-sm tw-text-gray-600">Property Manager</p>
  </div>

  <!-- Property Manager Email -->
  <div class="tw-mb-2">
    <a
      :href="`mailto:${property.property_manager.email}`"
      class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-blue-600 hover:tw-text-blue-800 tw-transition-colors"
    >
      <svg class="tw-h-4 tw-w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
      {{ property.property_manager.email }}
    </a>
  </div>

  <!-- Contact Button -->
  <a
    :href="property?.property_manager?.phone ? `tel:${property.property_manager.phone}` : `mailto:${property.property_manager.email}`"
    class="n-primary tw-w-full tw-max-w-xs tw-text-center"
  >
    Contact Manager
  </a>
</div>

</template>

<script lang="ts">

import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme4/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme4/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'FormCard',

 mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
       
      },
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.cardForm);
  },

  computed: {
    variant() {
      return useVariant(this.component);
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
